class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('submit', this.onFormSubmitNormalizeQuery.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmitNormalizeQuery(event) {
    if (typeof window.OVS_resolveExactSearchIntent !== 'function') {
      return;
    }

    const trimmedQuery = this.input.value.trim();
    const hardcodedSubline = (() => {
      const key = trimmedQuery.toLowerCase().replace(/['’]/g, '').replace(/\s+/g, ' ').trim();
      if (key === 'verka nu' || key === 'ver ka nu') {
        return {
          original_query: trimmedQuery,
          canonical_query: 'nu ver ka',
          matched_alias: null,
          exact_destination: null,
          phrase_shaped: false,
          resolver_strategy: 'subline_kit_search',
          resolver_payload: {
            phrase_key: key,
            display_query: trimmedQuery,
            filter_phrase_key: 'ver_ka nu',
          },
        };
      }
      return null;
    })();
    let resolved = hardcodedSubline || window.OVS_resolveExactSearchIntent(trimmedQuery);
    if (
      resolved.resolver_strategy !== 'subline_kit_search' &&
      typeof window.OVS_normalizePhraseKey === 'function' &&
      typeof window.OVS_parseMixedSublineProduct === 'function' &&
      typeof window.OVS_shopifyKitQueryFromSublinePhraseKey === 'function'
    ) {
      const phraseKey = window.OVS_normalizePhraseKey(trimmedQuery);
      const sublineMixed = window.OVS_parseMixedSublineProduct(phraseKey);
      if (sublineMixed) {
        resolved = {
          original_query: trimmedQuery,
          canonical_query: window.OVS_shopifyKitQueryFromSublinePhraseKey(phraseKey),
          matched_alias: null,
          exact_destination: null,
          phrase_shaped: false,
          resolver_strategy: 'subline_kit_search',
          resolver_payload: {
            phrase_key: phraseKey,
            display_query: trimmedQuery,
            filter_phrase_key: sublineMixed.filter_phrase_key,
          },
        };
      }
    }
    if (typeof window.OVS_trackSearchSubmit === 'function') {
      window.OVS_trackSearchSubmit(resolved, 'full_search');
    }
    if (resolved.exact_destination) {
      event.preventDefault();
      window.OVS_navigateExactSearchDestination(resolved, 'full_search');
      return;
    }

    // Grade/subline: keep the operator's words in ?q= (guard filters client-side). No session side channel.

    // Default form submit: ?q= matches what the customer typed.
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
